'use client';

import { useRef } from 'react';
import { trackLeadFormStage } from './metrika';

export function useLeadFormAnalytics(formType: string, trackOpenOnStart = true) {
  const started = useRef(false);
  const start = () => {
    if (started.current) return;
    started.current = true;
    if (trackOpenOnStart) trackLeadFormStage(formType, 'open');
    trackLeadFormStage(formType, 'start');
  };
  return {
    onFocusCapture: start,
    onChangeCapture: start,
    onSubmitCapture: () => trackLeadFormStage(formType, 'attempt'),
    onInvalidCapture: () => trackLeadFormStage(formType, 'error', 'validation'),
  };
}
